module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Pencil-840ac7f2ad8fa0ae854f1227e3372f4f.svg";